<template>
    <div>
        <mensajeSistema></mensajeSistema>
        <v-row class="ma-0" v-if="componenteEvento.agregar_submodulo">

            <v-col>
                <!-- <ButtonComp @click="verFiltros = true" textButton="filtros" iconBut="fas fa-filter" normalButton /> -->
                <v-tooltip right color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" color="primary" class="animate__animated animate__pulse animate__infinite"
                            @click="verFiltros = true">
                            <v-icon small left>fas fa-filter</v-icon>
                            Filtros
                        </v-btn>
                    </template>
                    <span>Filtros avanzados </span>
                </v-tooltip>

            </v-col>

            <v-col cols="auto">
                <ButtonComp @click="btnProgramar()" textButton="Programar evaluación" iconBut="fas fa-tasks"
                    normalButton />
            </v-col>

            <v-col cols="auto" class="">
                <ButtonComp @click="btnVerCalendario()" textButton="Calendario de evaluación" iconBut="fas fa-calendar"
                    classButton="ml-2" normalButton />
            </v-col>

            <v-col class="d-flex justify-end" cols="12">
                <v-text-field label="Buscar" dense small v-model="busquedaValor" placeholder="Buscar"
                    append-icon="fa-search" single-line outlined style="max-width: 400px" hide-details @keyup="
                        ((paginaActual = 1)),
                        listarEvaluaciones()
                        ">
                </v-text-field>
            </v-col>

            <v-col cols="12">
                <v-data-table dense :headers="GestionarEvaluacionHeaders" :items="dataEval" :options.sync="options"
                    :server-items-length="totalregistros" :loading="loading" :sort-desc="[false]"
                    class=" my-sticky-column-table" :footer-props="{
                        'items-per-page-options': [5, 10, 20],
                        'itemsPerPageText': 'Filas por página'
                    }">

                    <template v-slot:[`item.desc_curso`]="{ item }">
                        <span class="text-button">
                            <v-icon small :color="item.color_curso">{{ item.icono_curso }}</v-icon>{{ ' ' +
                                item.desc_curso
                            }}
                        </span>
                    </template>
                    <template v-slot:[`item.fecha`]="{ item }">

                        {{ item.fecha | filtroFecha }}
                    </template>
                    <template v-slot:[`item.action_hora`]="{ item }">
                        {{ item.hora_inicio | filtroFormatoHora }} - {{ item.hora_fin | filtroFormatoHora }}
                    </template>
                    <template v-slot:[`item.id_estado`]="{ item }">
                        <v-chip small dark class="font-weight-black" :color="item.color_estado">
                            {{ item.desc_estado }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.action_ver`]="{ item }">
                        <ButtonComp v-if="componenteEvento.editar_submodulo" @click="btnVerEval(item)"
                            tooltip-text="Ver evaluación" verButton />
                    </template>
                    <template v-slot:[`item.action_configurar`]="{ item }">
                        <div class="d-flex justify-center">

                            <ButtonComp v-if="item.id_estado == 5" reprogramarButton
                                tooltip-text="Reprogramar Evaluación" @click="btnReprogramarEval(item)" />

                            <ButtonComp v-if="componenteEvento.editar_submodulo && item.id_estado == 1" editButton
                                tooltip-text="Editar evaluación" @click="btnEditarEval(item)" />

                            <ButtonComp v-if="item.id_forma_evaluacion == 1" @click="btnCalificarV(item)" listButton
                                tooltip-text="Calificar evaluación" />
                            <ButtonComp v-if="item.id_forma_evaluacion == 2" @click="btnCalificarM(item)" listButton
                                tooltip-text="Calificar evaluación" />

                            <!-- <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="btnEliminarEval(item.id)"
                                deleteButton tooltip-text="Eliminar evaluación" /> -->

                        </div>

                    </template>
                </v-data-table>
            </v-col>

        </v-row>
        <!---------------------->
        <!--  DRAWER FILTROS  -->
        <v-navigation-drawer width="350" app v-model="verFiltros" fixed temporary right>

            <v-toolbar dense dark color="primary">
                <v-icon small left> fas fa-search </v-icon> Filtros de busqueda
                <v-spacer></v-spacer>
                <v-tooltip left color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                        <v-btn text small v-on="on" icon color="yellow" @click="resetearFiltros()" class="mr-1">
                            <v-icon>fa-sync-alt</v-icon>
                        </v-btn>
                    </template>
                    <span>Restablecer filtros </span>
                </v-tooltip>
                <v-btn fab dark x-small class="btn_style3" @click="verFiltros = false">
                    <v-icon dark>fa-times</v-icon>
                </v-btn>
            </v-toolbar>


            <v-list-item>
                <v-list-item-content>
                    <v-container>
                        <v-row>

                            <v-col cols="12">
                                <v-select dense label="Nivel:" v-model="filter.id_nivel"
                                    @change="cambiarNivel(filter.id_nivel)" :items="datosNiveles" item-value="id"
                                    item-text="desc_nivel">
                                </v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-select :disabled="datosGrados.length == 0" dense label="Grado:"
                                    v-model="filter.id_grado" @change="cambiarGrado(filter.id_grado)"
                                    :items="datosGrados" item-value="id" item-text="desc_grado">
                                </v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-select :disabled="datosAreas.length == 0" dense label="Área:"
                                    v-model="filter.id_area" @change="cambiarArea(filter.id_grado, filter.id_area)"
                                    :items="datosAreas" item-value="id" item-text="desc_area">
                                </v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-select :disabled="datosCursos.length == 0" dense label="Curso:"
                                    v-model="filter.id_curso" @change="listarEvaluaciones()" :items="datosCursos"
                                    item-value="id" item-text="desc_curso">
                                </v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-menu v-model="menuStartData" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-combobox dense v-model="filter.fecha_inicio" label="Fecha inicial" readonly
                                            v-bind="attrs" v-on="on" clearable
                                            @click:clear="filter.fecha_inicio = ''; listarEvaluaciones()"></v-combobox>
                                    </template>
                                    <v-date-picker v-model="filter.fecha_inicio"
                                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                                        no-title scrollable
                                        @input="menuStartData = false; listarEvaluaciones()"></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12">
                                <!-- :return-value.sync="date"  -->
                                <v-menu v-model="menuEndData" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-combobox dense v-model="filter.fecha_fin" label="Fecha final" readonly
                                            v-bind="attrs" v-on="on" clearable
                                            @click:clear="filter.fecha_fin = ''; listarEvaluaciones()">
                                        </v-combobox>
                                    </template>
                                    <v-date-picker v-model="filter.fecha_fin"
                                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                                        :min="filter.fecha_inicio" no-title scrollable
                                        @input="menuEndData = false; listarEvaluaciones()"></v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-list-item-content>
            </v-list-item>
        </v-navigation-drawer>

        <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseComp">
        </component>



        <confirm @aceptar="eliminarEval" titleWindow="Eliminar evaluación" @cancelar="clear_confirm"
            :title="confirm.title" :active="confirm.active" />
        <loadingSistema />
    </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import { GestionarEvaluacionHeaders } from "../../../helpers/headersTable";
import ClaseEvaluacionComp from "./components/ClaseEvaluacionComp.vue";
import ReprogramarEvaluacionComp from "./components/ReprogramarEvaluacionComp.vue";
import CalificarAlumnoVirtualComp from "./components/CalificarAlumnos/calificarAlumnosVirtualComp";
import CalificarAlumnoManualComp from "./components/CalificarAlumnos/calificarAlumnosManualComp";
import VisorEvaluacionComp from "@/views/Evaluacion/VisorEvaluacion/visorEvaluacion";
import CalendarioDocComp from "@/views/Evaluacion/Calendario/CalendarioDocente";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from "../../../components/ComponentsEst/ComundataTablecomp.vue";
import AutocompleteComp from "../../../components/ComponentsEst/AutocompleteComp.vue";
import io from 'socket.io-client';

export default {
    name: "ProgramacionEvaluacion",
    components: {
        ClaseEvaluacionComp,
        ReprogramarEvaluacionComp,
        ButtonComp,
        ComundataTablecomp,
        AutocompleteComp,
        VisorEvaluacionComp,
        CalificarAlumnoVirtualComp,
        CalificarAlumnoManualComp,
        CalendarioDocComp,
    },
    data: () => ({
        rutaservidor: API_URL,
        GestionarEvaluacionHeaders,
        // paramComponente: { id_modulo: 8, id_submodulo: 96 },
        datoLogin: sessionStorage,
        compName: null,
        estadoComponente: true,
        parametroComp: {},
        verFiltros: false,
        confirm: {
            id: 0,
            title: "",
            active: false,
        },
        search: "",
        dataEval: [],
        filter: {},
        id_docente: null,
        // PROPIEDADES DE PAGINACION
        paginaActual: 1,
        totalPaginas: 0,
        tamañoPorPagina: 10,
        tamañosPorPagina: [3, 6, 9],
        totalregistros: 0,
        busquedaValor: "",
        options: {},
        loading: true,

        menuStartData: false,
        menuEndData: false,

    }),
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento',
            periodoActual: 'globals/getPeriodosActual',
        }),
        ...mapState({
            datosDocente: state => state.globals.DocenteData,
            datosNiveles: state => state.globals.NivelesDocenteData,
            datosGrados: state => state.globals.GradosDocenteData,
            datosSeccion: state => state.globals.SeccionDocenteData,
            datosAreas: state => state.globals.AreasDocenteData,
            datosCursos: state => state.globals.CursosDocenteData,
        }),
    },
    watch: {
        options: {
            handler(newValor, oldValor) {
                this.tamañoPorPagina = newValor.itemsPerPage;
                if (newValor.itemsPerPage != oldValor.itemsPerPage) {
                    this.paginaActual = 1;
                }
                this.paginaActual = newValor.page;
                if (Object.keys(oldValor).length != 0) {
                    this.listarEvaluaciones();
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.loadMain(true);
        this.socket = io(API_URL);
        this.socket.on('evalActualizado', () => {
            this.loadMain();
        });
    },
    beforeDestroy() {
        this.socket.off('evalActualizado');
        this.socket.disconnect();
    },
    // created() {
    //     this.actualizarParamentro();
    // },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setResetFiltros: "globals/setResetFiltros",
            mostrarLoading: "mostrarLoading",
        }),
        ...mapActions({
            // parametroComponente: "login/parametroComponente",
            obtenerDocenteData: "globals/obtenerDocenteData",
            obtenerNivelesDocente: "globals/obtenerNivelesDocente",
            obtenerPeriodo: "globals/obtenerPeriodo",
            obtenerGradoDocente: "globals/obtenerGradoDocente",
            obtenerAreaDocente: "globals/obtenerAreaDocente",
            obtenerCursoDocente: "globals/obtenerCursoDocente",
            obtenerSeccionDocente: "globals/obtenerSeccionDocente",
        }),
        /**
         ________________________________
        | MÉTODO ACTUALIZAR PARAMETROS */
        // actualizarParamentro() {
        //     this.parametroComponente(this.paramComponente);
        // },
        /**
         ________________________
        | MÉTODO CARGA INICIAL */
        async loadMain(flag) {

            if (flag) {
                this.mostrarLoading({
                    titulo: "Cargando evaluaciones",
                    color: "#fff",
                    colorDialog: "#212121",
                    ancho: 300,
                });
                this.LimpiarForm();
            }

            this.setResetFiltros();
            await this.obtenerDocenteData(this.datoLogin.id);
            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_nivel: "",
                id_periodo: "",
                id_grado: "",
                id_area: "",
                id_curso: "",
                id_profesor: this.datosDocente.id_personal
            };

            this.listarEvaluaciones();
            await this.obtenerNivelesDocente({ id_colegio: this.datoLogin.id_colegio, id_ano_lectivo: this.datoLogin.id_ano_lectivo, id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null })

        },
        /**
         _____________________________
        | MÉTODO OBTENER PARAMETROS */
        obtenerParametros(
            valorBusqueda,
            paginaActual,
            tamañoPorPagina,
            filtros
        ) {
            let parametros = {};
            if (valorBusqueda) {
                parametros.valor = valorBusqueda;
            }
            if (paginaActual) {
                parametros.paginaActual = paginaActual - 1;
            }
            if (tamañoPorPagina) {
                parametros.tamañoPorPagina = tamañoPorPagina;
            }
            if (filtros) {
                parametros = { ...parametros, ...filtros };
            }
            return parametros;
        },
        /**
         _____________________________
        | MÉTODO LISTA EVALUACIONES */
        async listarEvaluaciones() {

            NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
            NProgress.start();
            this.loading = true
            const patrametosListar = this.obtenerParametros(
                this.busquedaValor,
                this.paginaActual,
                this.tamañoPorPagina,
                this.filter
            );

            try {
                const response = await axios.get("/evaluacion/programacion/listarEval", {
                    params: patrametosListar,
                });

                if (response.data.message) {
                    this.dataEval = [];
                } else {
                    let { filas, totalPaginas, totalFilas } = response.data;

                    this.dataEval = filas;
                    this.totalPaginas = totalPaginas;
                    this.totalregistros = totalFilas;

                }

                NProgress.done();
                this.$store.commit("ocultarLoading");
                this.loading = false

            } catch (error) {
                console.error(error);
                this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
            }
        },
        /**
         ____________________________
        | MÉTODO SELECCIONAR NIVEL */
        async cambiarNivel(id_nivel) {
            this.filter.id_grado = "";
            this.filter.id_area = "";
            this.filter.id_curso = "";

            await this.obtenerGradoDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                id_nivel
            })
            await this.obtenerPeriodo({
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_nivel
            })
        },
        /**
         ____________________________
        | MÉTODO SELECCIONAR GRADO */
        async cambiarGrado(id_grado) {
            this.filter.id_area = "";
            this.filter.id_curso = "";
            await this.obtenerAreaDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                id_grado
            });
            this.listarEvaluaciones();
        },
        /**
         ___________________________
        | MÉTODO SELECCIONAR AREA */
        async cambiarArea(id_grado, id_area) {
            this.filter.id_curso = "";

            await this.obtenerCursoDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                id_grado,
                id_area
            });
            this.listarEvaluaciones();
        },
        /**
         _________________________
        | MÉTODO VER EVALUACION */
        btnVerEval(items) {
            let params = {
                id_evaluacion: items.id,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_persona: items.id_persona,
                id_forma_evaluacion: items.id_forma_evaluacion,
                id_calificacion_evaluacion: items.id_calificacion_evaluacion,
                duracion_evaluacion: items.duracion_evaluacion,
            };

            let data = { evento: "view_docente", items: params };
            this.parametroComp = data;

            this.compName = "VisorEvaluacionComp";
            this.estadoComponente = true;
        },
        /**
         _________________________
        | MÉTODO VER CALENDARIO */
        btnVerCalendario() {
            //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
            this.parametroComp = {
                evento: "add",
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
            };
            this.compName = "CalendarioDocComp";
            this.estadoComponente = true;
        },
        /**
         ________________________________________
        | MÉTODO ABRIR MODAL PROGRAMAR EVALUAR */
        btnProgramar() {

            this.parametroComp = {
                evento: "add",
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                niveles: this.datosNiveles,
            };
            this.compName = "ClaseEvaluacionComp";
            this.estadoComponente = true;

        },
        /**
         ____________________________
        | MÉTODO EDITAR EVALUACION */
        btnEditarEval(items) {
            // this.setEnviarMens({tipo:"W", mensaje: `Editar Evaluación en Construcción`, tiempo:null})
            this.parametroComp = {
                evento: "edit",
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                items,
            };
            this.compName = "ClaseEvaluacionComp";
            this.estadoComponente = true;
        },

        /* 
        | MÉTODO PROGRAMAR EVALUACION (UNA VEZ ESTA ESTE CULMINADA) */
        btnReprogramarEval(items) {

            this.parametroComp = {
                evento: "reprogramar",
                id_docente: this.datosDocente.es_profesor == 1 ? this.datosDocente.id_personal : null,
                items,
            };

            this.compName = "ReprogramarEvaluacionComp";
            this.estadoComponente = true;

        },

        /**
         _______________________________________
        | MÉTODO CALIFICAR EVALUACION VIRTUAL */
        btnCalificarV(items) {
            this.parametroComp = { evento: "view", items };
            this.compName = "CalificarAlumnoVirtualComp";
            this.estadoComponente = true;
        },
        /**
         ______________________________________
        | MÉTODO CALIFICAR EVALUACION MANUAL */
        btnCalificarM(items) {
            // this.setEnviarMens({tipo:"W", mensaje: `Calificar Evaluación en Construcción`, tiempo:null})
            this.parametroComp = { evento: "view", items };
            this.compName = "CalificarAlumnoManualComp";
            this.estadoComponente = true;
        },
        /**
         ______________________________________
        | MÉTODO EVENT EMIT CERRAR COMPONENT */
        CloseComp() {
            this.estadoComponente = false;
            this.loadMain(false);
        },
        /**
       
         ______________________________
        | MÉTODO ELIMINAR EVAULACION */
        async btnEliminarEval(id) {
            this.confirm.active = true;
            this.confirm.title = "¿Está seguro que desea eliminar este registro?";
            this.confirm.id = id;
        },
        /**
         ___________________
        | MÉTODO ELIMINAR */
        async eliminarEval() {
            await axios
                .delete("/evaluacion/programacion/" + this.confirm.id)
                .then((resp) => {
                    if (resp.data.messageT == "S") {
                        this.clear_confirm();
                        this.listarEvaluaciones();

                        this.setEnviarMens({
                            tipo: resp.data.messageT,
                            mensaje: resp.data.message,
                            tiempo: null,
                        });
                    } else {
                        this.setEnviarMens({
                            tipo: 'E',
                            mensaje: 'No se puede eliminar esta evaluación porque tiene información asociada.',
                            tiempo: null,
                        });
                    }

                });
        },
        /**
         _____________________________
        | MÉTODO LIMPIAR FOMURLARIO */
        LimpiarForm() {
            // this.paramComponente = {};
            this.estadoComp = false;
        },
        /**
         ___________________________
        | MÉTODO RESETEAR FILTROS */
        resetearFiltros() {
            this.loadMain(false);
        },
        clear_confirm() {
            this.confirm.id = 0;
            this.confirm.title = "";
            this.confirm.active = false;
        },
    },
};
</script>

<style lang="sass" scoped>



.my-sticky-column-table

  thead tr:first-child th:first-child
    /* bg color is important for th; just specify one */
    background-color: #E0E0E0

  td:first-child
    background-color: #fff

  th:first-child,
  td:first-child
    position: sticky
    left: 0
    z-index: 1
</style>